module.exports = __webpack_public_path__ + "img/banner0.291803c.png";